'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAirlineSeatReclineExtra = function MdAirlineSeatReclineExtra(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27 25l9.6 7.5-2.5 2.5-6.3-5h-11.4q-1.8 0-3.2-1.1t-1.7-3l-2.3-9.8q-0.2-1.6 0.7-2.8t2.4-1.6h0q1.8-0.2 2.9 0.7l2.8 2.1q3.7 2.9 7.8 2.1v3.6q-3.8 0.7-8.6-2l1.7 6.8h8.1z m-0.4 6.6v3.4h-11.7q-3.1 0-5.4-2t-2.9-5l-3.2-16.4h3.2l3.3 15.8q0.3 1.8 1.7 3t3.3 1.2h11.7z m-17.7-22.2q-1.1-0.8-1.3-2.2t0.5-2.4 2.2-1.4 2.4 0.5q1.1 0.9 1.4 2.2t-0.5 2.5-2.2 1.3-2.5-0.5z' })
        )
    );
};

exports.default = MdAirlineSeatReclineExtra;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/airline-seat-recline-extra.js
// module id = 2798
// module chunks = 0